import CloseFullscreenOutlinedIcon from "@mui/icons-material/CloseFullscreenOutlined";
import OpenInFullIcon from "@mui/icons-material/OpenInFullRounded";
import { IconButton } from "@mui/material";
import type { Ref } from "react";
import React from "react";

interface ExpandButtonProps {
  ref?: Ref<HTMLButtonElement>;
  isExpanded: boolean;
  toggle: () => void;
}
const ChangeSizeButton = ({ ref, ...props }: ExpandButtonProps) => {
  const { isExpanded, toggle } = props;
  return (
    <IconButton onClick={toggle} ref={ref}>
      {isExpanded ? (
        <CloseFullscreenOutlinedIcon sx={(theme) => ({ color: theme.palette.secondary.light })} />
      ) : (
        <OpenInFullIcon sx={(theme) => ({ color: theme.palette.secondary.light })} />
      )}
    </IconButton>
  );
};

export default ChangeSizeButton;
